var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPool = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20 9.5C14.201 9.5 9.5 14.201 9.5 20S14.201 30.5 20 30.5 30.5 25.799 30.5 20 25.8 9.5 20 9.5Zm0 14.978a4.479 4.479 0 1 1 0-8.958 4.479 4.479 0 0 1 0 8.958ZM23.167 16.833l4.257-4.257M16.739 16.932l-4.228-4.228M23.167 23.386l4.257 4.257M16.739 23.287l-4.228 4.228"
}))));
export default SvgPool;